import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-types-papi';
import { useWatchButton } from '@wix/da-shared-react/pkg/WatchButton/useWatchButton';
import GhostButton from '@wix/da-shared-react/pkg/Buttons/GhostButton';
import SolidButton from '@wix/da-shared-react/pkg/Buttons/SolidButton';
import Plus from '@wix/da-shared-react/pkg/Icons/Plus';
import Check from '@wix/da-shared-react/pkg/Icons/Check';

export interface Props {
  user: PapiUser;
  disabled?: boolean;
  className?: string;
}

const WatchGroupButton: React.FC<Props> = ({ user, disabled, className }) => {
  const { t } = useTranslation();
  const { isWatching, biData, onClick } = useWatchButton(
    user,
    user.isWatching,
    false,
    disabled
  );

  if (isWatching) {
    return (
      <GhostButton
        size="small"
        variant="approval-green"
        className={className}
        biData={biData}
        onClick={onClick}
        icon={Check}
      >
        {t('subnavigation.button.watchingGroup')}
      </GhostButton>
    );
  }
  return (
    <SolidButton
      size="small"
      variant="branded-green"
      className={className}
      biData={biData}
      onClick={onClick}
      icon={Plus}
    >
      {t('subnavigation.button.watchGroup')}
    </SolidButton>
  );
};
WatchGroupButton.displayName = 'WatchGroupButton';

export default WatchGroupButton;
